import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles({
  cardImage: {
    composes: ['card-image'],
    height: 206,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 0,
    backgroundImage: (props) => `url(${props.src})`,
  },
});
const CardImage = ({ src }) => {
  const style = useStyle({ src });

  return (
    <div className={style.cardImage} />
  );
};

export default CardImage;
